import React from 'react';
import { Link } from 'react-router-dom';

const LAST_UPDATED = 'April 2, 2026';

type Props = {
  title: string;
  children: React.ReactNode;
};

const LegalPageLayout: React.FC<Props> = ({ title, children }) => {
  return (
    <div className="bg-gray-50 min-h-screen pb-16">
      <div className="container mx-auto px-4 sm:px-6 py-8 sm:py-12 max-w-3xl">
        <nav className="text-sm text-gray-500 mb-6" aria-label="Breadcrumb">
          <Link to="/" className="text-green-700 hover:text-green-800 font-medium">
            Home
          </Link>
          <span className="mx-2 text-gray-400">/</span>
          <span className="text-gray-700">{title}</span>
        </nav>

        <article className="bg-white rounded-2xl border border-gray-200 shadow-sm p-6 sm:p-10">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 tracking-tight">{title}</h1>
          <p className="text-sm text-gray-500 mt-2 mb-8">Last updated: {LAST_UPDATED}</p>
          <div className="text-gray-700">{children}</div>
        </article>

        <nav
          className="mt-8 flex flex-wrap gap-x-6 gap-y-2 text-sm text-gray-600 border-t border-gray-200 pt-8"
          aria-label="Legal"
        >
          <Link to="/terms" className="hover:text-green-700 font-medium">
            Terms of Service
          </Link>
          <Link to="/privacy" className="hover:text-green-700 font-medium">
            Privacy Policy
          </Link>
          <Link to="/cookies" className="hover:text-green-700 font-medium">
            Cookie Policy
          </Link>
        </nav>
      </div>
    </div>
  );
};

export default LegalPageLayout;
